import React from 'react';
import AiManagementBiddingFiles from 'components/molecules/ai_management_bidding_files';
import { useEditalFiles } from 'hooks/useEditalFiles';

interface AiManagementUpdateEditalFilesProps {
  biddingId: number;
}

const AiManagementUpdateEditalFiles: React.FC<AiManagementUpdateEditalFilesProps> = ({
  biddingId,
}) => {
  const { files, loading, error } = useEditalFiles(biddingId);

  return (
    <div className="mt-3">
      <div className="font-weight-bold mb-2">Arquivos do edital</div>
      <AiManagementBiddingFiles files={files} loading={loading} error={error} />
    </div>
  );
};

export default AiManagementUpdateEditalFiles;
